import FlowActionTypes from 'app/editor/ActionTypes';
import reducer from 'app/editor/reducer';
import routes from 'app/editor/routes';

export default {
  reducers: {
    flow: reducer,
  },
  actionTypes: FlowActionTypes,
  routes,
};
